/**
 * Main App Component
 */

import { useEffect } from "react"
import { RouterProvider } from "react-router-dom"
import { LanguageProvider } from "@/components/providers/LanguageProvider"
import { Toaster } from "@/components/ui/toaster"
import { ThemeProvider } from "@/context/ThemeContext"
import { NotificationRealtimeProvider } from "@/contexts/NotificationRealtimeContext"
import { RealtimeProvider } from "@/contexts/RealtimeContext"
import { router } from "./routes"
import "@/language"
import { useAuthStore } from "@/features/auth/store/authStore"
import { getProfile } from "@/features/profile/services/user.service"

function App() {
  useEffect(() => {
    const accessToken = localStorage.getItem("access_token")
    if (accessToken) {
      getProfile()
        .then(({ user }) => useAuthStore.getState().setUser(user))
        .catch(console.error)
    }
  }, [])

  return (
    <ThemeProvider>
      <LanguageProvider>
        <RealtimeProvider>
          <NotificationRealtimeProvider>
            <RouterProvider router={router} />
            <Toaster />
          </NotificationRealtimeProvider>
        </RealtimeProvider>
      </LanguageProvider>
    </ThemeProvider>
  )
}

export default App
